import React, { Component, createRef } from 'react';
import Header from '../components/Principal/Header';
import Footer from '../components/Principal/Footer';
import MensajeF from '../components/Mensaje_Flotante/MensajeF';
import Seccion01CooperaGanaMas from '../components/EstrategiasComerciales/CooperaGanaMas/Seccion01CooperaGanaMas';
import Seccion02CooperaGanaMas from '../components/EstrategiasComerciales/CooperaGanaMas/Seccion02CooperaGanaMas';
import Seccion03CooperaGanaMas from '../components/EstrategiasComerciales/CooperaGanaMas/Seccion03CooperaGanaMas';

class EstComCooperaGanaMas extends Component {
    constructor(props) {
        super(props);
        this.seccion02Ref = createRef();
        this.seccion03Ref = createRef();
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    scrollToSection = (sectionId) => {
        if (sectionId === 2 && this.seccion02Ref.current) {
            this.seccion02Ref.current.scrollIntoView({ behavior: 'smooth' });
        } else if (sectionId === 3 && this.seccion03Ref.current) {
            this.seccion03Ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    render() {

        return (
            <>
                <Header id={2} />
                <div style={{ paddingTop: '118px' }}>
                    <Seccion01CooperaGanaMas onButtonClick={this.scrollToSection}/>
                </div>

                <div ref={this.seccion02Ref}>
                    <Seccion02CooperaGanaMas />
                </div>

                <div ref={this.seccion03Ref}>
                    <Seccion03CooperaGanaMas />
                </div>

                <MensajeF />
                <Footer />
            </>
        );
    }
}

export default EstComCooperaGanaMas;